import InstitutionFuturesCompanyInformationForm from '@/features/institution/futures/company-information/components/form';
import InstitutionFuturesCompanyInformationLayout from '@/features/institution/futures/company-information/layout';

const InstitutionFuturesCompanyInformationPage = () => {
  return (
    <InstitutionFuturesCompanyInformationLayout>
      <InstitutionFuturesCompanyInformationForm />
    </InstitutionFuturesCompanyInformationLayout>
  );
};
InstitutionFuturesCompanyInformationPage.displayName = 'InstitutionFuturesCompanyInformationPage';

export default InstitutionFuturesCompanyInformationPage;
